import routes from './routes'
import store from './store'

export default {
    name: 'm-profiles',
    store: store,
    routes: routes
}